import { render, staticRenderFns } from "./InfoIcon.vue?vue&type=template&id=294c3fa3&scoped=true&"
import script from "./InfoIcon.vue?vue&type=script&lang=ts&"
export * from "./InfoIcon.vue?vue&type=script&lang=ts&"
import style0 from "./InfoIcon.vue?vue&type=style&index=0&id=294c3fa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c3fa3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VIcon,VMenu})
